export default __webpack_public_path__ + "static/media/tenispage.f29c5719.PNG";